import React from "react";
import PropTypes from "prop-types";
import Card from "../../../../_shared/Card";
import { CTAButton2 } from "../../../../_shared/buttons";

export default function SDOHError({ errorMessage, backFunction, retryFunction }) {
  return (
    <Card style={{ maxWidth: 400, textAlign: "center" }}>
      Something went wrong: {errorMessage} <br /><br />
      Either go back to the member profile again or click to fill out a default status capture
      <div>
        <CTAButton2 onClick={backFunction}>Back to Member Profile</CTAButton2>
      </div>
      <div>
        <CTAButton2 onClick={retryFunction}>Status Capture</CTAButton2>
      </div>
      <br />
      <div>
        If this error continues contact{" "}
        <a href="mailto:support@samaritan.com">support</a>
      </div>
    </Card>
  );
}

SDOHError.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  retryFunction: PropTypes.func.isRequired,
};
